import { render, staticRenderFns } from "./StarterBookingStatistics.vue?vue&type=template&id=dc7f8498&scoped=true"
import script from "./StarterBookingStatistics.vue?vue&type=script&lang=js"
export * from "./StarterBookingStatistics.vue?vue&type=script&lang=js"
import style0 from "./StarterBookingStatistics.vue?vue&type=style&index=0&id=dc7f8498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7f8498",
  null
  
)

export default component.exports